// extracted by mini-css-extract-plugin
export default {"root":"LoadingSpinner_root__Z5Lz4","ip":"LoadingSpinner_ip__zn5nw","track":"LoadingSpinner_track__Trn5U","worm1":"LoadingSpinner_worm1__bFjlF","worm2":"LoadingSpinner_worm2__UaWJW"};